import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

export const SuppliersTableNoDataField = (): ReactElement => {
  return <Typography.Text>—</Typography.Text>
}
